/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDefinitionParameterValueDto
 */
export interface CreateDefinitionParameterValueDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterValueDto
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDefinitionParameterValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterValueDto
     */
    parameterIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterValueDto
     */
    $type?: CreateDefinitionParameterValueDtoTypeEnum;
}


/**
 * @export
 */
export const CreateDefinitionParameterValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionParameterValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDefinitionParameterValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateDefinitionParameterValueDtoTypeEnum = typeof CreateDefinitionParameterValueDtoTypeEnum[keyof typeof CreateDefinitionParameterValueDtoTypeEnum];



/**
 * Check if a given object implements the CreateDefinitionParameterValueDto interface.
 */
export function instanceOfCreateDefinitionParameterValueDto(value?: unknown): value is CreateDefinitionParameterValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateDefinitionParameterValueDtoTypeEnum)[0];
}

export function CreateDefinitionParameterValueDtoFromJSON(json: any): CreateDefinitionParameterValueDto {
    return CreateDefinitionParameterValueDtoFromJSONTyped(json, false);
}

export function CreateDefinitionParameterValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDefinitionParameterValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'value': json['value'] == null ? undefined : json['value'],
        'parameterIdentifier': json['parameterIdentifier'] == null ? undefined : json['parameterIdentifier'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateDefinitionParameterValueDtoToJSON(value?: CreateDefinitionParameterValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'value': value['value'],
        'parameterIdentifier': value['parameterIdentifier'],
        '$type': value['$type'],
    });
}

